module.exports = __webpack_public_path__ + "static/img/A55.dbc6e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/A55.png
// module id = tPBq
// module chunks = 0